// 福利商城
export const welfareMallRouter = [
  {
    path: '/service/welfareMall/enterprise',
    name: 'WelfareMallEnterprise',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallEnterprise'),
    meta: {
      title: '企业管理',
      keepAlive: false
    }
  },
  {
    path: '/service/welfareMall/staffList',
    name: 'WelfareMallStaffList',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallStaffList'),
    meta: {
      title: '员工管理',
      keepAlive: false
    }
  },
  {
    path: '/service/welfareMall/authentication',
    name: 'WelfareMallAuthentication',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallAuthentication'),
    meta: {
      title: '认证管理',
      keepAlive: false
    }
  },
  {
    path: '/service/welfareMall/settings',
    name: 'WelfareMallSettings',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallSettings'),
    meta: {
      title: '商城设置',
      keepAlive: false
    }
  },
  {
    path: '/service/welfareMall/staffRights',
    name: 'WelfareMallStaffRights',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallStaffRights'),
    meta: {
      title: '员工权益',
      keepAlive: false
    }
  },
  {
    path: '/service/welfareMall/hotelOrder',
    name: 'WelfareMallHotelOrder',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallHotelOrder'),
    meta: {
      maxStyle: true,
      title: '酒店订单',
      keepAlive: false
    }
  },
  {
    path: '/service/welfareMall/planeTicketOrder',
    name: 'WelfareMallPlaneTicketOrder',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallPlaneTicketOrder'),
    meta: {
      maxStyle: true,
      title: '机票订单',
      keepAlive: false
    }
  },
  {
    path: '/service/welfareMall/trainTicketOrder',
    name: 'WelfareMallTrainTicketOrder',
    component: () => import('@/views/service/serviceProvider/welfareMall/WelfareMallTrainTicketOrder'),
    meta: {
      maxStyle: true,
      title: '火车票订单',
      keepAlive: false
    }
  }
]
